/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'
const BusinessIntelligence = ({ rawUrl }) => {

    var aaa = readUrl();
    const [state, setState] = useState(aaa);

    
    return (
        <MasterPage state={state} >
        <>
         

            {/* About Section */}
            <section id="about" className="wow fadeInUp" style={{ backgroundColor: 'white' }}>
                <div className="container">
                    <div className="row">
                        <img
                            src="/theme/img/bi-tools-preview.jpg"
                            alt="BI Tools Preview"
                            style={{ height: '300px' }}
                        />
                    </div>
                    <br />
                    <div className="row">
                        <h2 className="elementor-heading-title elementor-size-default">
                            Visualising a better business
                        </h2>
                        <p>
                            There is no doubt that data visualisations can be a powerful tool. Columns of numbers tend to hide the
                            important information you need to drive business improvements, whereas a well thought-out chart or map can
                            provide moments of sheer clarity. The key is visualising the data in the right way � four steps to next
                                level analytics in {state.condText}
                        </p>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-lg-6 about-img">
                            <img
                                src="/theme/img/business-intelligence-2-768x512.jpg"
                                alt="Business Intelligence Tools"
                                className="img-fluid"
                            />
                        </div>
                        <div className="col-lg-6 content">
                            <h2 className="elementor-heading-title elementor-size-default">
                                Advanced analytics to help you improve your business processes and outcomes.
                            </h2>
                            <p>
                                An ever-increasing volume of data � accelerated by mobile devices, social media, eCommerce and more
                                sophisticated ERP processes � can be overwhelming. On a practical level, distilling and managing data
                                can be difficult, especially when there are a number of different sources. Tejaxo iQ makes it easy for
                                you to turn your data into insights that bring clarity and certainty to your decision-making.
                            </p>
                            <p>
                                <b>Investigate</b>&nbsp;with accurate, timely snapshots of the market
                            </p>
                            <p>
                                <b>Understand</b>&nbsp;emerging trends and needs, insights into your organisation�s performance and new
                                opportunities for growth
                            </p>
                            <p>
                                <b>Forecast</b>&nbsp;answers to �What if?� scenarios
                            </p>
                            <p>
                                <b>Compete</b>&nbsp;where you have the edge
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    </MasterPage>
        );


};

export default BusinessIntelligence;
